import { render, staticRenderFns } from "./StepForm.vue?vue&type=template&id=6a0df210&"
import script from "./StepForm.vue?vue&type=script&lang=js&"
export * from "./StepForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/.pnpm/vue-loader@15.10.0_babel-core@7.0.0-bridge.0_@babel+core@7.19.3__cache-loader@4.1.0_web_c7e2a9737e7b7d65140c95ac56c8a121/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports